import { BaseViewModel, IEntityConstructorOptions } from "./Base/BaseViewModel";
import { UserProfile } from "../Services/DataService/Model/UserProfile";
import { GetAuthServices } from "../Services/AuthService/AuthService";
import { GetCorrelation, ICorrelation } from "./Utilities";
import { DataEntityBase, Models } from "../Services/DataService/Model";
import { ModelManager } from "./ModelManager";
import { BasicEntityWatcher } from "../Services/DataService/EntityWatcher";
import { IConstructorOptions } from "../Utilities";



export class UserProfileViewModel extends BaseViewModel {


    public static get TypeName() { return Models.UserProfile; };
    public get TypedData() { return ((this.Data as unknown) as UserProfile); }

    public static Manager = new ModelManager<UserProfileViewModel>({
        createFN:
            async (options?: IEntityConstructorOptions) => {
                try {

                    var retVal: UserProfileViewModel;

                    if (options) {
                        retVal = new UserProfileViewModel(options);
                    }
                    else {

                        const auth = await GetAuthServices();
                        var resourceToken = await auth.AcquireIdToken() as any;
                        var ourOptions: IEntityConstructorOptions = { sourceObject: {} };
                        ourOptions.sourceObject.id = UserProfile.CreateId(resourceToken.sub);
                        ourOptions.sourceObject.firstName = resourceToken.given_name;
                        ourOptions.sourceObject.lastName = resourceToken.family_name;
                        ourOptions.sourceObject.createdDate = new Date();
                        //
                        // Disabling email colelction/verification until it as actually used
                        //
                        // if (resourceToken.emails !== undefined && resourceToken.emails.length > 0)
                        //     this.TypedData.email = resourceToken.emails[0];
                        // if (resourceToken.emails !== undefined && resourceToken.emails.length > 0)
                        //     ourOptions.sourceObject.email = resourceToken.emails[0];
                        retVal = new UserProfileViewModel(ourOptions);
                        retVal.TypedData.ForcePropertyChangedNotification();
                    }
                    return retVal;
                }
                catch (e) {
                    console.error(e);
                    throw new Error("Unable to create User Profile");
                }

            },
        idFromKeyFN: (key: string) => UserProfile.CreateId(key),
        typeName: Models.UserProfile,
    });

    public static async GetModel() {

        if (this._instance === undefined) {
            const auth = await GetAuthServices();

            var allProfiles = await UserProfileViewModel.Manager.GetAllItems(GetCorrelation());

            var userProfile: UserProfileViewModel | null = null;
            if (allProfiles.length === 1) {
                userProfile = allProfiles[0];
            }
            else if (allProfiles.length === 0) {
                let resourceToken = await auth.AcquireIdToken() as any;

                userProfile = await UserProfileViewModel.Manager.GetItemByKey(GetCorrelation(), resourceToken.sub);
                if (userProfile === null)
                    userProfile = await UserProfileViewModel.Manager.CreateItem(GetCorrelation());
            }


            if (!userProfile)
                throw new Error('Unable to create user profile');

            if (auth.IsTestAccount()) {
                userProfile.TypedData.isTestAccount = true;
            }

            this._instance = userProfile;
        }
        return this._instance;
    }
    private static _instance: UserProfileViewModel | undefined = undefined;

    protected CreateData(watcher: BasicEntityWatcher, options?: IConstructorOptions) {
        return UserProfile.Create(watcher, options);
    }


    protected onReplacedData(_oldData?: DataEntityBase, _newData?: DataEntityBase) {
        // No work to do, but need to override anyway.
    }

    protected async doHydrate(_correlation: ICorrelation, _isRehydrate?: boolean): Promise<void> {
        // No work to do, but need to override anyway.
    }

    private constructor(options?: IEntityConstructorOptions) {
        super(options);


        this.SetHydrated();

        if (this.TypedData.firstName === "" || this.TypedData.lastName === "") {
            GetAuthServices().then(async (auth) => {
                var resourceToken = await auth.AcquireIdToken() as any;
                this.TypedData.userId = resourceToken.sub;
                this.TypedData.key = resourceToken.sub;
                this.TypedData.firstName = resourceToken.given_name;
                this.TypedData.lastName = resourceToken.family_name;
                if (this.TypedData.createdDate === undefined)
                    this.TypedData.createdDate = new Date();
                //
                // Disabling email colelction/verification until it as actually used
                //
                // if (resourceToken.emails !== undefined && resourceToken.emails.length > 0)
                //     this.TypedData.email = resourceToken.emails[0];
            });
        }

        if (this.TypedData.createdDate === undefined)
            this.TypedData.createdDate = new Date();
    }


}